import React, { ReactNode } from 'react'
import { FormNewsletter, PageLanding, NewsletterHero } from 'components/organisms'
import styles from './LandingTemplate.module.sass'
import { WContainer, WImage } from '@components/atoms'


const LandingTemplate = ({
  pagina,
  from,
  children,
  preferenzeOpen,
  brand,
}: {
  pagina?: any
  from?: string
  children?: ReactNode
  preferenzeOpen?: boolean
  brand?: any
}) => (
  <PageLanding
    pagina={pagina}
    item={{}}
    contentClassName={styles.registrazioneTemplate}
    headerLogo={brand?.newsletterLogo || brand?.image}
    headerLogoAlt={brand?.name}
    footerHideStores={!!brand}
    theme={{
      pageBgColor: brand?.newsletterPageBgColor,
      heroBgColor: brand?.newsletterHeroBgColor,
      heroTextColor: brand?.newsletterHeroTextColor,
      primaryColor: brand?.newsletterPrimaryColor,
      primaryTextColor: brand?.newsletterPrimaryTextColor,
      headBgColor: brand?.newsletterHeadBgColor,
      footerBgColor: brand?.newsletterFooterBgColor,
      footerTextColor: brand?.newsletterFooterTextColor,
    }}
  >
    <NewsletterHero
      title={brand?.newsletterTitle || pagina?.titolo}
      description={brand?.newsletterDescription || pagina?.descrizione}
      image={brand?.newsletterHeroImage || pagina?.mainImage}
      imageMobile={pagina?.previewImage}
    />
    <WContainer variant="md">
      {!!brand?.newsletterFormTopText && (
        <div
          className={styles.formIntro}
          dangerouslySetInnerHTML={{ __html: brand?.newsletterFormTopText }}
        />
      )}
      <div className={styles.formSection}>
        {!!brand?.newsletterFormImage && (
          <div className={styles.formImage}>
            <WImage
              src={brand?.newsletterFormImage}
              alt={brand?.name}
              title={brand?.name}
              maxWidth={420}
              maxHeight={420}
              objectFit="contain"
            />
          </div>
        )}
        <div className={styles.container}>
          {(!!brand?.newsletterFormTitle ||
            !!brand?.newsletterFormDescription ||
            !!pagina?.titolo ||
            !!pagina?.descrizione) && (
            <div className={styles.head}>
              {!!(brand?.newsletterFormTitle || pagina?.titolo) && (
                <h1 className={styles.title}>
                  {brand?.newsletterFormTitle || pagina?.titolo}
                </h1>
              )}
              {!!(brand?.newsletterFormDescription || pagina?.descrizione) && (
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{
                    __html: brand?.newsletterFormDescription || pagina?.descrizione,
                  }}
                />
              )}
            </div>
          )}
          <FormNewsletter
            from={from}
            preferenzeOpenDefault={preferenzeOpen}
            enablePreferenzeToggle={!!brand}
            brandOptinName={brand?.optinName}
            brandName={brand?.name}
            brandSlug={brand?.domain}
          />
        </div>
      </div>
    </WContainer>
  </PageLanding>
)

export default LandingTemplate
